import { useTheme } from 'styled-components';

// --------------------------------------------------------------------------

export const FormConfirmationLines = ({
  className,
}: {
  className?: string;
}) => {
  const { midwestColors: colors } = useTheme();
  return (
    <svg className={className} width="160" height="160" viewBox="0 0 160 160">
      <filter id="noiseFilter">
        <feTurbulence
          baseFrequency="0.004"
          numOctaves="2"
          result="turbulence"
        />
        <feDisplacementMap
          in2="turbulence"
          in="SourceGraphic"
          scale="20"
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>
      <defs>
        <g id="lines-1" filter="url(#noiseFilter)">
          <line
            strokeLinecap="round"
            stroke={colors.neutralDarkWeak}
            strokeWidth="1.5"
            y1="-79"
            y2="-71"
          />
          <circle cx="100" cy="100" r="50" fill="none" />
        </g>
        <g id="lines-2" filter="url(#noiseFilter)">
          <line
            strokeLinecap="round"
            stroke={colors.neutralDarkWeak}
            strokeWidth="1.5"
            x1="-79"
            x2="-71"
          />
          <circle cx="100" cy="100" r="50" fill="none" />
        </g>
      </defs>
      <g transform="translate(80 80)">
        <use xlinkHref="#lines-1" transform="rotate(15)" />
        <use xlinkHref="#lines-1" transform="rotate(25)" />
        <use xlinkHref="#lines-1" transform="rotate(35)" />
        <use xlinkHref="#lines-1" transform="rotate(45)" />
        <use xlinkHref="#lines-1" transform="rotate(55)" />
        <use xlinkHref="#lines-1" transform="rotate(65)" />
        <use xlinkHref="#lines-1" transform="rotate(75)" />
        <use xlinkHref="#lines-1" transform="rotate(85)" />
        <use xlinkHref="#lines-2" transform="rotate(15)" />
        <use xlinkHref="#lines-2" transform="rotate(25)" />
        <use xlinkHref="#lines-2" transform="rotate(35)" />
        <use xlinkHref="#lines-2" transform="rotate(45)" />
        <use xlinkHref="#lines-2" transform="rotate(55)" />
        <use xlinkHref="#lines-2" transform="rotate(65)" />
      </g>
    </svg>
  );
};
